import { jsx as _jsx } from "react/jsx-runtime";
import { ChartProvider, ChartWidget, PredictionChartCard, } from "@madmedical/ui";
import { invariant, rangeToDate } from "@madmedical/utils";
import { usePatientId } from "@madmedical/user";
import Chart from "../../charts/Chart";
import { useGetMeasurementRangeQuery } from "../../measurement/api";
const PredictionChart = ({ prediction: { dateRange, extendedRange }, trend, }) => {
    const { metricType } = trend;
    const { patientId } = usePatientId();
    const { data, isLoading } = useGetMeasurementRangeQuery({
        userId: patientId,
        metricType,
        queryRange: extendedRange,
        statsRange: dateRange,
    });
    if (isLoading) {
        return null;
    }
    invariant(data);
    const { worstAlertLevel, displayRange, unit } = data.stats;
    return (_jsx(ChartProvider, Object.assign({ value: {
            chart: (_jsx(Chart, { metricType: metricType, data: data, dateRange: rangeToDate(extendedRange), widget: ChartWidget.Page, predictionTrend: trend })),
            metricType,
            dateRange: rangeToDate(dateRange),
            displayRange: displayRange ? `${displayRange} ${unit}` : null,
            alertLevel: worstAlertLevel,
        } }, { children: _jsx(PredictionChartCard, {}) })));
};
export default PredictionChart;
